<script>
/**
 * ****************************************************************************
 * @description     :   Main component for popup MST_005 (統括部_新)
 * @created at      :   2026/01/21
 * @created by      :   longvv
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import store from '@/store';
import template from './template.html';
import { mapState, mapMutations, mapActions } from 'vuex';
import PopupMST005 from '@/views/popupSearch/PopupMST005/store';
import helpers from '@/utils/helpers';

var PopupMST005Index = {
    template: template,
    props: {
        onSelected: Function,
        id: String,
        initData: [String, Number, Object],
        isShowFooter: Boolean
    },
    beforeCreate() {
        if (!store.hasModule('PopupMST005')) {
            store.registerModule('PopupMST005', PopupMST005);
        }
    },
    created() {
        this.onInitScreen();
        this.applyInitData();
        this.onSearchItem();
    },
    data() {
        return {};
    },
    emits: ['close', 'onReferModelValue', 'onReferValueName'],
    computed: {
        ...mapState('PopupMST005', ['listData', 'data', 'totalRows', 'msgNoData'])
    },
    methods: {
        ...mapMutations('app', ['showHeaderError', 'showModalMessage']),
        ...mapActions('PopupMST005', ['searchAreaInfo']),
        ...mapMutations('PopupMST005', ['resetDataInit', 'setPageNavigation', 'setPageNo']),
        applyInitData() {
            if (this.initData && typeof this.initData === 'object') {
                if (this.initData.company_cd !== undefined) {
                    this.data.company_cd = this.initData.company_cd;
                }
                if (this.initData.center_cd !== undefined) {
                    this.data.center_cd = this.initData.center_cd;
                }
                if (this.initData.department_cd !== undefined) {
                    this.data.department_cd = this.initData.department_cd;
                }
                if (this.initData.department_name !== undefined) {
                    this.data.department_name = this.initData.department_name;
                }
            } else if (this.initData !== undefined && this.initData !== null) {
                this.data.department_cd = this.initData;
            }
        },
        onSearchItem() {
            this.setPageNavigation({
                currentPage: 1,
                perPage: this.data.pageSize
            });
            this.searchAreaInfo(this.data);
        },
        changeCurrentPage(data) {
            this.data.pageNo = data.currentPage;
            this.data.pageSize = data.perPage;
            this.searchAreaInfo(this.data);
        },
        onInitScreen() {
            helpers.removeAllRequireInput();
            this.resetDataInit();
        },
        chooseItem(item) {
            this.$emit('onReferModelValue', item.department_cd);
            this.$emit('onReferValueName', item.department_name);
            this.$emit('close');
        }
    }
};
export default PopupMST005Index;
</script>

<style lang="scss">
@use '@/assets/scss/common/popup.scss' as *;
</style>
